import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const keyTransportsForPermit = ({ clientId, houseId }) => [
  'transport-permit-for-permit',
  clientId,
  houseId,
];

const getTransports = async (values) => {
  return await request.get(
    `/TransportPermit/transport/for_permit`,
    values,
    'При загрузке транспортных средств произошла ошибка',
    []
  );
};

const useTransportForPermitQuery = ({ clientId, houseId }, options = {}) => {
  return useQuery(
    keyTransportsForPermit({ clientId, houseId }),
    () => getTransports({ clientId, houseId }),
    options
  );
};

export default useTransportForPermitQuery;
